
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "focusable": "false",
    "viewBox": "0 0 16 16",
    "aria-hidden": "true",
    "role": "presentation",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M6.196,5.907H2.588V6.34h3.608V5.907z M2.588,9.515h4.33V9.082h-4.33V9.515z M5.763,7.495H2.588v0.433 h3.175V7.495z M4.753,4.32H2.588v0.433h2.165V4.32z M9.515,2.588c0,0-0.627,0-0.866,0H8.505c-0.353,0-0.503,0.243-0.503,0.433 c0-0.17-0.154-0.433-0.508-0.433H7.206c-0.239,0-0.866,0-0.866,0H1v10.68h6.639c0.09,0,0.144,0.07,0.144,0.144h0.433 c0-0.079,0.062-0.144,0.144-0.144H15V2.588C15,2.588,9.515,2.588,9.515,2.588z M7.784,3.598c0,0.159,0,9.237,0,9.237H1.433V3.021 H6.34c0,0,0.706,0,0.866,0h0.289c0.159,0,0.289,0.129,0.289,0.289V3.598z M14.567,12.835H8.216c0,0,0-9.078,0-9.237V3.309 c0-0.159,0.129-0.289,0.289-0.289h0.289c0.159,0,0.722,0,0.722,0h5.052V12.835z M9.371,11.103h3.608V10.67H9.371V11.103z M9.371,6.34h2.021V4.32H9.371V6.34z M9.804,4.753h1.155v1.155H9.804V4.753z M9.371,9.515h4.33V9.082h-4.33V9.515z M9.371,7.928 h2.887V7.495H9.371V7.928z M2.588,11.103h2.165V10.67H2.588V11.103z"
      }
    }
  ]
})
    }
  